<template>
  <div class="hotel-edit-accordion-1">
    <div class="form--row">
      <!-- NOME -->
      <PmwFormInput
        :value="name"
        :error="errors.includes('Nome')"
        :required="true"
        :showCounter="true"
        maxlength="80"
        data-error="Nome"
        label="Nome do hotel"
        placeholder="Ex. Hotel Praia Funda"
        class="form--input__large"
        id="form--name"
        @input="$emit('changeName', $event)"
      />

      <!-- MARCA -->
      <PmwFormInput
        :value="brand"
        :error="errors.includes('Marca')"
        :required="true"
        :showCounter="true"
        maxlength="50"
        data-error="Marca"
        label="Marca"
        class="form--input__large"
        id="form--brand"
        @input="$emit('changeBrand', $event)"
      />

      <!-- CNPJ DO HOTEL -->
      <CnpjInput
        ref="cnpjInput"
        :value="cnpj"
        :error="errors.includes('Cnpj')"
        label="CNPJ do Hotel"
        class="form--input__large"
        data-error="Cnpj"
        id="form--cnpj"
        @input="$emit('changeCnpj', $event)"
        @validation="$emit('cnpjValidation', $event)"
      />
    </div>

    <!-- LOCALIZAÇÃO -->
    <div class="reference-tour" id="form--location-title">
      <PmwHeading size="paragraph-80" weight="weight-light" class="form--title">
        Localização do hotel
      </PmwHeading>

      <div class="form--row">
        <!-- CEP -->
        <PmwFormInput
          :value="cep"
          :error="errors.includes('Endereco.Cep')"
          :required="true"
          :hasMask="true"
          data-error="Endereco.Cep"
          mask="#####-###"
          label="CEP"
          placeholder="00000-000"
          class="form--input__cep"
          @input="getAddress($event)"
        />

        <!-- ENDEREÇO -->
        <PmwFormInput
          :value="address"
          :error="errors.includes('Endereco.Endereco')"
          :required="true"
          data-error="Endereco.Endereco"
          label="Endereço"
          placeholder="Insira o nome da rua, avenida, etc."
          class="form--input__address"
          @input="$emit('changeAddress', $event)"
        />

        <!-- COMPLEMENTO -->
        <PmwFormInput
          :value="complement"
          label="Complemento"
          placeholder="Bloco, complexo, etc."
          class="form--input__complement"
          @input="$emit('changeComplement', $event)"
        />
      </div>

      <div class="form--row">
        <!-- BAIRRO -->
        <PmwFormInput
          :value="district"
          :error="errors.includes('Endereco.Bairro')"
          :required="true"
          label="Bairro"
          data-error="Endereco.Bairro"
          placeholder="Insira o bairro"
          class="form--input"
          @input="$emit('changeDistrict', $event)"
        />

        <!-- CIDADE -->
        <PmwFormSelect
          :value="city"
          :options="cities"
          :search="true"
          :required="true"
          :error="errors.includes('endereco.codigoCidade')"
          data-error="endereco.codigoCidade"
          label="Cidade"
          placeholder="Selecione a cidade"
          class="form--input form--input__select"
          @input="updateCity($event)"
        />

        <!-- INFORMAÇÕES SOBRE AS CIDADES -->
        <PmwParagraph class="form--info" size="paragraph-40">
          Não encontrou a cidade? <br />
          <router-link to="/cidades" class="link" target="_blank"
            >Clique aqui para configurar</router-link
          >
        </PmwParagraph>
      </div>

      <div class="form--row">
        <!-- ESTADO -->
        <PmwFormInput
          :value="state"
          :disabled="true"
          label="Estado"
          placeholder=""
          class="form--input"
          @input="$emit('changeState', $event)"
        />

        <!-- PAÍS -->
        <PmwFormInput
          :value="country"
          :disabled="true"
          label="País"
          placeholder=""
          class="form--input"
          @input="$emit('changeCountry', $event)"
        />
      </div>

      <div class="form--row mb-0">
        <!-- LATITUDE -->
        <PmwFormInput
          v-model="latitude"
          :disabled="true"
          :infoIcon="true"
          tooltipMinWidth="190"
          infoText="Utilizado para Google HotelAds"
          placeholder=""
          label="Latitude"
          class="form--input__latitude"
        />

        <!-- LONGITUDE -->
        <PmwFormInput
          v-model="longitude"
          :disabled="true"
          :infoIcon="true"
          tooltipMinWidth="190"
          infoText="Utilizado para Google HotelAds"
          placeholder=""
          label="Longitude"
          class="form--input__latitude"
        />
      </div>
    </div>
  </div>
</template>

<script>
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'
import PmwFormInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormInput'
import PmwFormSelect from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormSelect'
import CnpjInput from '@/components/_base/patterns/CnpjInput'

export default {
  name: 'NameAndAdress',
  components: {
    PmwHeading,
    PmwParagraph,
    PmwFormInput,
    PmwFormSelect,
    CnpjInput
  },
  props: {
    name: {
      type: String,
      default: null
    },

    cnpj: {
      type: String,
      default: null
    },

    brand: {
      type: String,
      default: null
    },

    cep: {
      type: String,
      default: null
    },

    address: {
      type: String,
      default: null
    },

    complement: {
      type: String,
      default: null
    },

    district: {
      type: String,
      default: null
    },

    city: {
      type: Object,
      default: () => {}
    },

    state: {
      type: String,
      default: null
    },

    country: {
      type: String,
      default: null
    },

    latitude: {
      type: [String, Number],
      default: null
    },

    longitude: {
      type: [String, Number],
      default: null
    },

    /** Erros (array de erros que foram identificados pelo back-end) */
    errors: {
      type: Array,
      default: () => []
    },

    /** Listagem de cidades */
    cities: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    /** Pegar os dados do endereço através do CEP
     * @param {String} cep: Verificar se o campo é válido e buscar o endereço
     */
    async getAddress(cep) {
      /** Atualizar o campo do cep */
      this.$emit('changeCep', cep)

      /** Verificar se está editando ou criando o hotel */
      const isEdition = this.$route.params.id || false
      if (cep.length === 9 && isEdition) {
        const response = await this.$zipCode.get(cep)
        /** Atualizar o bairro */
        const district =
          response.data && response.data.bairro
            ? response.data.bairro
            : this.district
        this.$emit('changeDistrict', district)
        /** Atualizar o logradouro */
        const address =
          response.data && response.data.logradouro
            ? response.data.logradouro
            : this.address
        this.$emit('changeAddress', address)
      } else if (cep.length === 9 && !isEdition) {
        const response = await this.$zipCode.get(cep)
        /** Atualizar o bairro */
        const district = response.data ? response.data.bairro : null
        this.$emit('changeDistrict', district)
        /** Atualizar o logradouro */
        const address = response.data ? response.data.logradouro : null
        this.$emit('changeAddress', address)
      }
    },

    /** Pegar a data e atualizar os campos de estado e país
     * @param {Object} city - Dados da cidade
     */
    updateCity(city) {
      this.$emit('changeCity', city)
      this.$emit('changeState', city.estado)
      this.$emit('changeCountry', city.pais)
    }
  }
}
</script>

<style lang="scss" scoped>
.reference-tour {
  position: relative;
}

.pmw-form-field {
  ::v-deep {
    .pmw-form-field--label {
      font-weight: font-weight('weight-medium');
    }
    .form-field--label-wrapper {
      line-height: 21px;
      margin-bottom: 3px;
    }
    .pmw-input {
      background: $white;
    }
    .pmw-input--clear {
      z-index: 0;
    }
    .pmw-input__focus {
      border-color: $pmw-blue;
    }

    .pmw-input--field {
      background: $pmw-white;

      &:focus {
        border-color: $pmw-blue;
      }
    }

    .pmw-input__disabled {
      input {
        background: pmw-colors('grey-20');
        color: $pmw-gray-darker;
      }
    }

    .pmw-custom-tooltip {
      line-height: 18px;
    }
  }
  &.disabled {
    opacity: unset;
    filter: unset;
    pointer-events: unset;

    &::v-deep {
      .pmw-form-field--label,
      .pmw-form-field--asterisk {
        color: $pmw-gray-mid;
      }

      .pmw-input,
      .pmw-input input {
        filter: grayscale(1);
        pointer-events: none;
        background: $pmw-gray-bg;
      }
    }
  }
}

.form {
  &--input {
    max-width: 248px;

    /** Alterar cores novas do select */
    ::v-deep {
      .pmw-select--button__caret-sort-up,
      .pmw-select--button__show {
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select--button:focus {
        border-color: pmw-colors('blue-100');
        border-bottom-color: pmw-colors('blue-100');
      }
      .pmw-select-options--item__hover:hover,
      .pmw-select-options--item__checked {
        background-color: pmw-colors('blue-100') !important;
      }
      .pmw-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    &__disabled {
      ::v-deep {
        .pmw-form-field--label,
        .pmw-form-field--asterisk {
          color: $pmw-gray-mid;
        }
        .pmw-select {
          filter: grayscale(1);
          pointer-events: none;
          background: $pmw-gray-bg;
        }
      }
    }

    &__large {
      max-width: 248px;
    }

    &__select {
      width: 250px;
      max-width: 250px;

      &.error {
        ::v-deep {
          .pmw-select--button {
            border-bottom-color: pmw-colors('error-100');
            border-bottom-width: 2px;
          }
        }
      }
    }

    &__cep {
      max-width: 90px;
    }

    &__address {
      max-width: 310px;
    }

    &__number {
      max-width: 115px;
    }

    &__complement {
      max-width: 225px;
    }

    &__latitude {
      max-width: 176px;
    }
  }

  &--info {
    line-height: 18px;
    flex: 1;
  }

  &--row {
    display: flex;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 54px;
    margin-bottom: 32px;
  }

  &--title {
    color: pmw-colors('blue-100');
    font-weight: font-weight('weight-medium');
    margin-bottom: 32px;
    position: relative;
  }
}

.link {
  color: $pmw-blue;

  &:hover {
    color: $pmw-blue;
    text-decoration: underline;
  }
}
</style>
